<template>
  <el-card>
    <!-- <el-input style="width:250px;" placeholder="用户名/手机号/邮箱">
       <el-button  slot="append" icon="el-icon-search"></el-button>
    </el-input>-->
    <el-table border style="width:100%;margin-top:20px;" :data="tableData">
      <el-table-column label="姓名" width="180" prop="username"></el-table-column>
      <el-table-column label="角色" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.roleid == 1">平台管理员</div>
          <div v-if="scope.row.roleid == 2">平台运维人员</div>
          <div v-if="scope.row.roleid == 3">文联工作人员</div>
          <div v-if="scope.row.roleid == 4">共享联盟成员</div>
          <div v-if="scope.row.roleid == 5">平台成员</div>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" width="180" prop="email"></el-table-column>
      <el-table-column label="手机号" width="180" prop="mobile"></el-table-column>
      <el-table-column label="创建时间" width="180" prop="createTime"></el-table-column>
      <el-table-column label="最后登录时间" width="180" prop="lastLoginTime"></el-table-column>
      <el-table-column fixed="right" label="操作" min-width="180">
        <template slot-scope="scope" >
          <el-button @click="returnUser(scope.row.id)" type="text">恢复</el-button>
          <el-button @click="deleteUser(scope.row.id)" type="text">彻底删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:20px;"
      @current-change="handleCurrentChange"
      :page-size="limit"
      :current-page="page"
      background
      layout="prev, pager, next"
      :total="total"
    ></el-pagination>
  </el-card>
</template>

<script>
import { async } from "q";
export default {
  data: function() {
    return {
      tableData: [],
      page: 1,
      total: 0,

      limit: 20
    };
  },
  methods: {
    handleCurrentChange: function(val) {
        this.page = val
        this.getRecycleList();
    },
    getRecycleList: async function() {
      var res = await this.$http.get(
        `/v1/busUser/recycleList?page=${this.page}&limit=${this.limit}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        this.tableData = data;
      }
    },
    // 恢复
    returnUser: function(id) {
      this.$confirm("是否恢复账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var res = await this.$http.post(
            `/v1/busUser/recycleDeleteBusUser?id=${id}&status=regain`
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("恢复成功");
            this.getRecycleList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 彻底删除
    deleteUser: function(id) {
      this.$confirm("是否彻底删除账号？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var res = await this.$http.post(
            `/v1/busUser/recycleDeleteBusUser?id=${id}&status=del`
          );
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("彻底删除成功");
            this.getRecycleList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {});
    }
  },
  mounted: function() {
    this.getRecycleList();
  }
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/backgroundMg/staff-mg/recycle.vue